// custom article search bar
const debounce = (func, wait = 300) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

const handleArticleInput = debounce(async function (inputEl) {
  const searchTerm = inputEl.value.trim();
  const suggestionBox = document.querySelector('.article-suggestions');

  // Remove suggestions and overflow if input is empty
  if (!searchTerm.length) {
    suggestionBox.classList.remove('open');
    setTimeout(() => {
      suggestionBox.innerHTML = '';
    }, 400); // match transition duration
    document.body.style.overflow = '';
    return;
  } else {
    document.body.style.overflow = 'hidden';
  }

  try {
    const blogMatch = window.location.pathname.match(/^\/blogs\/([^\/]+)/);
    const blogHandle = blogMatch?.[1] || '';
    const fields = 'title,body,product_type,vendor,variants.title,variants.sku';

    let params = `q=${encodeURIComponent(searchTerm)}&resources[type]=article&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=${fields}`;
    if (blogHandle) {
      params += `&resources[options][blogs]=${blogHandle}`;
    }

    params += '&section_id=predictive-search';

    const response = await fetch(`/search/suggest?${params}`);
    if (!response.ok) throw new Error(response.status);
    const text = await response.text();
    const tmpl = document.createElement('template');
    tmpl.innerHTML = text;
    const resultsEl = tmpl.content.querySelector('#shopify-section-predictive-search');
    const articles = resultsEl?.querySelector('[data-type="articles"]');

    if (articles && articles.innerHTML.trim().length > 0) {
      suggestionBox.innerHTML = articles.innerHTML;
      suggestionBox.classList.add('open');
    } else {
      suggestionBox.innerHTML = `
        <div class="js-search-results" tabindex="-1" data-predictive-search="">
          <p> </p>
          <p class="text--large text--center">No results could be found.</p>
          <div class="button-wrapper text--center" style="margin-bottom:20px;">
            <button type="button" data-action="reset-search" class="button button--primary">New search</button>
          </div>
        </div>`;
      suggestionBox.classList.add('open');

      setTimeout(() => {
        const resetBtn = suggestionBox.querySelector('[data-action="reset-search"]');
        if (resetBtn) {
          resetBtn.addEventListener('click', () => {
            inputEl.value = '';
            suggestionBox.classList.remove('open');
            setTimeout(() => {
              suggestionBox.innerHTML = '';
            }, 400); // clean after animation
            document.body.style.overflow = '';
            inputEl.focus();
          });
        }
      }, 0);
    }
  } catch (err) {
    console.error('Error fetching article suggestions:', err);
    suggestionBox.classList.remove('open');
    setTimeout(() => {
      suggestionBox.innerHTML = '';
    }, 400);
    document.body.style.overflow = '';
  }
}, 300);

document.querySelector('form.custom_article_search').addEventListener('keydown', function(event) {
    if (event.key === 'Enter' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
    }
});
// end custom article search bar
//short by product

document.addEventListener('DOMContentLoaded', function () {
  const radios = document.querySelectorAll('.sort-by-radio');
  const articles = document.querySelectorAll('.blog_letf_hashtag[data-article-product]');
  const paginationArticle = document.querySelector('.pagination');
  const sortLabel = document.getElementById('sort-by-selected-value');
  const popover = document.getElementById('sort-by-popover');
  const toggleButton = document.querySelector('.popover-button[aria-controls="sort-by-popover"]');

  function updateSortLabel(text) {
    sortLabel.textContent = text || 'Search by Products';
  }

  function showAllArticles() {
    articles.forEach(article => article.style.display = 'block');
    if (paginationArticle) paginationArticle.style.display = '';
    updateSortLabel('Search by Products');
  }

  function filterArticles(selectedHandle, titleText) {
    if (paginationArticle) paginationArticle.style.display = 'none';

    articles.forEach(article => {
      const dataHandles = article.getAttribute('data-article-product') || '';
      if (dataHandles.includes(selectedHandle)) {
        article.style.display = 'block';
      } else {
        article.style.display = 'none';
      }
    });

    updateSortLabel(titleText);
  }

  function closePopover() {
    if (popover) popover.removeAttribute('open');
    if (toggleButton) toggleButton.setAttribute('aria-expanded', 'false');
  }

  radios.forEach(radio => {
    radio.addEventListener('click', function () {
      const wasChecked = this.getAttribute('data-waschecked') === 'true';

      radios.forEach(r => r.setAttribute('data-waschecked', 'false'));

      if (wasChecked) {
        this.checked = false;
        this.setAttribute('data-waschecked', 'false');
        showAllArticles();
      } else {
        this.setAttribute('data-waschecked', 'true');
        const titleText = this.getAttribute('title') || this.value;
        filterArticles(this.value, titleText);
      }

      // Always close popover after click
      closePopover();
    });
  });
});


//end short by product